export default "__VITE_ASSET__BbomhSDf__"